function getTileValue(tile) {
  return typeof tile === 'object' && tile !== null ? tile.value : tile;
}

function canPlaceOnStack(stack, value) {
  if (stack.length === 0) return getTileValue(value) === 1;
  return getTileValue(stack[stack.length - 1]) + 1 === getTileValue(value);
}

function evaluateColumn(column, value, difficulty) {
  if (column.length === 0) return difficulty === 'easy' ? 2 : 8;
  const top = getTileValue(column[column.length - 1]);
  const diff = getTileValue(value) - top;

  if (difficulty === 'easy') return Math.random() * 5 - Math.abs(diff);
  if (difficulty === 'medium') return top - value - Math.max(0, diff);
  if (difficulty === 'hard') return top >= value ? 16 - (top - value) : -2 * diff;
  return top >= value ? 26 - (top - value) : -3 * diff;
}

function pickColumn(columns, value, difficulty) {
  let best = 0;
  let bestScore = Number.NEGATIVE_INFINITY;
  columns.forEach((col, index) => {
    const score = evaluateColumn(col, value, difficulty);
    if (score > bestScore) {
      bestScore = score;
      best = index;
    }
  });
  return best;
}

export function computeAiMove({ columns, stacks, tileValue, difficulty }) {
  for (let i = 0; i < stacks.length; i += 1) {
    if (canPlaceOnStack(stacks[i], tileValue)) {
      return { targetType: 'stack', targetIndex: i };
    }
  }

  const targetIndex = pickColumn(columns, tileValue, difficulty);
  return { targetType: 'column', targetIndex };
}

export function calculateScore(stacks) {
  return stacks.reduce((sum, stack) => sum + (stack.length ? getTileValue(stack[stack.length - 1]) : 0), 0);
}
